module.exports = __webpack_public_path__ + "static/media/industries.8fe5c97a.jpg";